import { HttpClient } from "@angular/common/http";
import { Component, OnDestroy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { Config } from "../../config.const";

@Component({
    selector: 'app-domande-risposte-appuntamento',
    styleUrls: ['./domande-risposte-appuntamento.css'],
    templateUrl: './domande-risposte-appuntamento.html'
})
export class DomandeRisposteAppuntamentoComponent implements OnDestroy {
    subArray: Subscription[] = []
    risposte = []

    set idAppuntamento(id) {
        this.load(id)
    }

    constructor(private http: HttpClient, public activeModal: NgbActiveModal) {
    }






    load(id) {
        this.subArray.push(
            this.http.get(`${Config.baseURL}/impostazioni/domande-risposte-appuntamento?id_appuntamento=${id}`).subscribe(response => {
                this.risposte = (response as any[])
            })
        )
    }









    ngOnDestroy(): void {
        this.subArray.forEach(s => s.unsubscribe())
    }
}


// WEBPACK FOOTER //
// ./src/app/opzioni/domande-risposte-appuntamento/domande-risposte-appuntamento.ts